// @ts-nocheck
import { useSelector } from "react-redux";
import { getCurrentContent } from "../store/content/selectors";
import { ILanguageInfo, IContent } from "../store/content/types";
import { IAppState } from "../store";

interface IUnit {
  [key: string]: string;
}
interface IUnits {
  [key: string]: IUnit;
}

interface IContentfulMap {
  languageInfo: ILanguageInfo[];
  managerAppCommon: IContent;
  managerAppDevices: IContent;
  managerAppError: IContent;
  managerAppLogin: IContent;
  managerAppModals: IContent;
  managerAppOverview: IContent;
  managerAppInstallation: IContent;
  managerAppProduct: IContent;
  managerAppSales: IContent;
  managerAppSidebar: IContent;
  managerAppWelcome: IContent;
  managerAppSettings: IContent;
  mediaContainer: string[];
  emailDomains: string;
  units: IUnits;
}

const initialContent: IContentfulMap = {
  languageInfo: [],
  managerAppCommon: {},
  managerAppDevices: {},
  managerAppError: {},
  managerAppLogin: {},
  managerAppModals: {},
  managerAppOverview: {},
  managerAppInstallation: {},
  managerAppProduct: {},
  managerAppSales: {},
  managerAppSidebar: {},
  managerAppWelcome: {},
  managerAppSettings: {},
  mediaContainer: [],
  units: {},
  emailDomains: ""
};

const useContent: () => IContentfulMap = () => {
  const content = useSelector((state: IAppState) => getCurrentContent(state));

  return {
    // @ts-ignore
    languageInfo: [],
    managerAppCommon: {},
    managerAppDevices: {},
    managerAppError: {},
    managerAppLogin: {},
    managerAppModals: {},
    managerAppOverview: {},
    managerAppInstallation: {},
    managerAppProduct: {},
    managerAppSales: {},
    managerAppSidebar: {},
    managerAppWelcome: {},
    managerAppSettings: {},
    mediaContainer: [],
    units: {},
    emailDomains: "",
    ...initialContent,
    ...((content as IContentfulMap) || {})
  };
};

export default useContent;
